import { AddIcon, Button } from '@shared/components';

import { useRoleUserManagementModal } from '../../providers';

export default function RoleUserAdditionButton() {
  const { setAction } = useRoleUserManagementModal();

  const handleClickAddToRoleUser = () => {
    setAction('role-user-addition');
  };
  return (
    <Button startIcon={<AddIcon />} onClick={handleClickAddToRoleUser}>
      Add User
    </Button>
  );
}
